import { useNavigate, useParams } from 'react-router-dom'
import ProjectBreadcrumb from '../project-tables/ProjectBreadcrumb'
import { useGetIntegration } from '@/service-library/hooks/integrations'
import LargeHeading from '../large-heading/LargeHeading'
import CopyIDButton from '../copy-id-button/CopyIDButton'
import { Button, Container, Stack, Typography } from '@mui/material'
import { Delete } from '@mui/icons-material'
import useOverlay from '@/hooks/useOverlay'
import DeleteIntegrationDialog from './DeleteIntegrationDialog'
import LabeledProgressIndicator from '../labeled-progress-indicator/LabeledProgressIndicator'

export default function IntegrationSettings() {
  const { integrationId } = useParams<{ integrationId: string }>()
  const { integration } = useGetIntegration({
    id: integrationId as string,
    enabled: !!integrationId,
    filters: {
      fields__include: 'integration_type',
    },
  })

  const navigate = useNavigate()

  const deleteOverlay = useOverlay()

  if (!integration) {
    return (
      <Stack justifyContent="center" sx={{ width: '100%' }}>
        <LabeledProgressIndicator>
          <Typography variant="body1" component="span">
            Loading Integration...
          </Typography>
        </LabeledProgressIndicator>
      </Stack>
    )
  }

  return (
    <Container maxWidth="md">
      <ProjectBreadcrumb label="Integrations" url="../general" />
      {integration && (
        <>
          <ProjectBreadcrumb label={integration.name} />

          <LargeHeading
            heading={integration.name}
            subHeading="Integration Settings"
            actions={
              <>
                <Button
                  variant="text"
                  startIcon={<Delete />}
                  color="error"
                  onClick={() => deleteOverlay.open()}
                >
                  Delete
                </Button>

                <DeleteIntegrationDialog
                  integration={integration}
                  overlay={deleteOverlay}
                  onSuccess={() => navigate('../general')}
                />
                <CopyIDButton stringToCopy={integration.id} />
              </>
            }
          />
        </>
      )}

      <Stack direction="row" sx={{ mt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          This integration does not have any settings.
        </Typography>
      </Stack>
    </Container>
  )
}
